import {
  GET_AUDIT_LOG_SUCCESS,
  CLEAR_AUDIT_LOG,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

let initialState = {
  byKey: {},
};

export const auditLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUDIT_LOG_SUCCESS:
      return { ...state, byKey: setAuditData(state, action) };

    case CLEAR_AUDIT_LOG:
    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

function setAuditData(state, action) {
  const key = action.requestInfo.resourceType + action.requestInfo.id;

  return {
    ...state.byKey,
    [key]: action.result,
  };
}
